<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="600px"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="80px" label-position="top" style="width: 100%">
          <el-form-item
            :label="this.$t('SeaExport.ShippingCompanyContractNo')"
            style="width: 50%;padding-right: 10px; box-sizing: border-box;"
            class="compact-form-item"
            :required="true"
          >
            <el-input v-model="form.contractNumber" no="contractNumber" :placeholder="$t('SeaExport.PleaseEnterTheShippingCompanyContractNumber')" @input="handleContractNumberInput" />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.ContractRateProperty')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
            :required="true"
          >
            <el-select
              v-model="form.priceNature"
              no="priceNature"
              :placeholder="$t('SeaExport.PleaseSelect')"
              :clearable="false"
              size="mini"
            >
              <el-option
                v-for="(item,index) in bookingTerms"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="this.$t('Message.ApplicableRoute')"
            style="width: 100%; padding-right: 10px; box-sizing: border-box;"
            class="compact-form-item"
          >
            <cargo-advance-select
              filterable
              multiple
              :default-multiple-value="form.applicableRoutes"
              :select-type="selectTypeNames.basic_data_Region"
              :placeholder="$t('SeaExport.PleaseSelectAirLine')"
              @parentCallBack="p=>{form.applicableRoutes=p.value}"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.ShippingCompany')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
          >
            <cargo-company-select
              no="shippingCompany"
              :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
              :default-value="form.shippingCompany||''"
              :placeholder="$t('SeaExport.PleaseSelectShippingCompany')"
              @change="p=>{form.shippingCompany=p.value}"
            />
          </el-form-item>
          <el-form-item style="width: 50%; padding-right: 10px;box-sizing: border-box;" />
          <el-form-item
            :label="this.$t('SeaExport.IsNac')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
          >
            <el-select
              v-model="form.weatherNac"
              no="weatherNac"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
              :clearable="true"
              @change="handleNacChange"
            >
              <el-option
                v-for="item in SystemConstants.YESORNO_COMMON_STATES"
                :key="item.code"
                :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="showNacFields"
            label="NAC"
            style="width: 100%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
            :required="true"
          >
            <!-- 初始输入框 + 添加按钮 -->
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <el-input v-model="form.defaultParam" no="defaultParam" style="width: 100%;max-width: 800px" :placeholder="$t('SeaExport.PleaseEnterNAC')+1" @input="(val) => $emit('update:form', { ...form, defaultParam: val })" />
              <el-button
                type="text"
                style="color: #42b983; margin-left: 10px;"
                icon="el-icon-circle-plus"
                @click="addNacForm"
              />
            </div>

            <!-- 动态生成的输入框列表 -->
            <div v-for="(nac, index) in form.nacList" :key="nac.uuid" style="margin-bottom: 10px;">
              <div style="display: flex; align-items: center;">
                <el-input
                  v-model="nac.param"
                  :data-uuid="nac.uuid"
                  no="param"
                  style="width: 100%"
                  :placeholder="$t('SeaExport.PleaseEnterNAC')+Number(index+2)"
                />
                <el-button
                  type="text"
                  style="color: #f56c6c; margin-left: 10px;"
                  icon="el-icon-remove"
                  @click="deleteNacForm(nac,index)"
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item
            :label="this.$t('SeaExport.ApplicableProductName')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
          >
            <el-select
              v-model="form.applicableProducts"
              no="applicableProducts"
              :placeholder="$t('SeaExport.PleaseSelect')"
              :clearable="false"
              size="mini"
              @change="handleProductNameChange"
            >
              <el-option
                v-for="(item,index) in productNames"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="showProductName"
            :label="this.$t('SeaExport.CommodityName')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            :required="true"
            class="compact-form-item"
          >
            <el-input v-model="form.productName" no="productName" :placeholder="$t('SeaExport.PleaseEnterTheCommodityNameOrHSCode')" />
          </el-form-item>
          <el-form-item
            label="MQC"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
          >
            <el-input v-model="form.mqc" no="mqc" length="100" type="number" :placeholder="$t('SeaExport.PleaseInputNumber')" oninput="value=value.replace(/[^0-9]/g,'')">
              <!-- 右侧固定文本 -->
              <template slot="append">
                <span>TEU</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="this.$t('SeaExport.CargoInsurance')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
          >
            <el-select
              v-model="form.cabinGuarantee"
              no="cabinGuarantee"
              :placeholder="$t('SeaExport.PleaseSelect')"
              @change="handleCabinGuaranteeChange"
            >
              <el-option
                v-for="item in SystemConstants.HAVENONE_STATES"
                :key="item.code"
                :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="showCabinGuarantee"
            :label="this.$t('SeaExport.CargoInsuranceQuantity')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
            :required="true"
          >
            <auto-number-input v-model="form.cabinQuantity" no="cabinQuantity" :placeholder="$t('SeaExport.PleaseInputNumber')" :precision="2" />
          </el-form-item>
          <el-form-item
            v-if="showCabinGuarantee"
            :label="this.$t('SeaExport.CargoInsuranceUnit')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
            :required="true"
          >
            <el-select
              v-model="form.cabinUnit"
              no="cabinUnit"
              :placeholder="$t('SeaExport.PleaseSelect')"
              :clearable="false"
              size="mini"
            >
              <el-option
                v-for="(item,index) in cabinUnitNames"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="this.$t('SeaExport.ValidityStartDate')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            :required="true"
            class="compact-form-item"
          >
            <el-date-picker
              no="validityStart"
              class="departure-date-picker"
              :value="form.validityStart"
              type="date"
              value-format="yyyy-MM-dd"
              style="flex: 1;margin-right: 5px"
              @input="validityStartChange"
            />
          </el-form-item>
          <el-form-item
            :label="this.$t('SeaExport.ValidityEndDate')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            :required="true"
            class="compact-form-item"
          >
            <el-date-picker
              no="validityEnd"
              class="departure-date-picker"
              :value="form.validityEnd"
              type="date"
              value-format="yyyy-MM-dd"
              style="flex: 1;margin-right: 5px"
              @input="validityEndChange"
            />
          </el-form-item>
          <el-form-item
            v-if="this.isEdit"
            :label="this.$t('Message.IsEnable')"
            style="width: 50%; padding-right: 10px;box-sizing: border-box;"
            class="compact-form-item"
          >
            <el-select
              v-model="form.weatherEnabled"
              :disabled="true"
              no="weatherEnabled"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
              :clearable="true"
            >
              <el-option
                v-for="item in SystemConstants.YESORNO_COMMON_STATES"
                :key="item.code"
                :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import {
  BOOKING_TERMS,
  CABIN_UNIT_NAMES, CABIN_UNIT_TEU_WATER,
  PRODUCT_NAMES,
  PRODUCT_OTHER
} from '@/class/cargo/model/parameters/SeaExportConstants'
import { HAVENONE_STATES, STATE_HAVE, YESORNO_COMMON_STATES } from '@/class/cargo/model/parameters/SystemConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { isExistContractNumber, saveShippingContract } from '@/api/price/priceFcl'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'

export default {
  name: 'ShippingContractWindow',
  components: {
    AutoNumberInput,
    cargoCompanySelect, CargoAdvanceSelect, CargoOwnedBranchSelect, cargoUserSelect },
  props: {
    visible: { type: Boolean, required: true },
    form: { type: Object, default: () => {} },
    title: { type: String, default: '' },
    isEdit: { type: Boolean, default: false },
    filterJson: { type: Object, default: () => {} }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      prefix: '',
      rules: [],
      checkNoRule: true,
      generativeRules: SystemConstants.GENERATIVE_RULES,
      officeList: [],
      departmentArray: [],
      bookingTerms: BOOKING_TERMS,
      productNames: PRODUCT_NAMES,
      cabinUnitNames: CABIN_UNIT_NAMES,
      showNacFields: false, // 控制NAC字段显示
      showProductName: false, // 控制品名
      showCabinGuarantee: false, // 控制舱保数量和舱保单位
      nacDefaultParam: '',
      removeUuids: []
    }
  },
  computed: {
    YESORNO_COMMON_STATES() {
      return YESORNO_COMMON_STATES
    },
    HAVENONE_STATES() {
      return HAVENONE_STATES
    },
    SystemConstants() {
      return SystemConstants
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        }
      }
    }
  },
  watch: {
    'form.weatherNac': {
      handler(newVal) {
        if (newVal) {
          this.showNacFields = true
        } else {
          this.showNacFields = false
        }
      },
      immediate: true // 立即触发一次（可选）
    },
    'form.cabinGuarantee': {
      handler(newVal) {
        if (newVal) {
          this.showCabinGuarantee = true
          this.form.cabinUnit = SeaExportConstants.CABIN_UNIT_TEU_WATER.code
        } else {
          this.showCabinGuarantee = false
          this.form.cabinUnit = ''
          this.form.cabinQuantity = ''
        }
      },
      immediate: true // 立即触发一次（可选）
    },
    'form.applicableProducts': {
      handler(newVal) {
        if (newVal === SeaExportConstants.PRODUCT_OTHER.code) {
          this.showProductName = true
        } else {
          this.showProductName = false
        }
      },
      immediate: true // 立即触发一次（可选）
    }
  },
  mounted() {},
  methods: {
    addNacForm() {
      if (this.form.nacList && this.form.nacList.length === 9) {
        return
      }
      this.$set(this.form.nacList, this.form.nacList.length, { param: null })
    },
    deleteNacForm(nac, index) {
      this.form.nacList.splice(index, 1)
      // 获取删除元素的uuid
      const deletedUuid = this.form.uuids[index + 1]
      this.removeUuids.push(deletedUuid)
    },
    close() {
      this.innerVisible = false
    },
    async saveHandler() {
      if (!this.form.contractNumber) {
        this.$message.warning(this.$t('SeaExport.ShippingCompanyContractNoRequired'))
        return
      }
      if (this.form.priceNature === SeaExportConstants.BOOKING_TERM_OS.code && this.form.applicableRoutes.length === 0) {
        this.$message.warning(this.$t('SeaExport.ApplicableRoutesNoRequired'))
        return
      }
      if ([SeaExportConstants.BOOKING_TERM_OS.code, SeaExportConstants.BOOKING_TERM_CS.code].includes(this.form.priceNature) && !this.form.shippingCompany) {
        this.$message.warning(this.$t('SeaExport.ShippingCompanyNoRequired'))
        return
      }
      if (!this.form.validityStart || !this.form.validityEnd) {
        this.$message.warning(this.$t('SeaExport.ValidityNoRequired'))
        return
      }
      if (!this.form.priceNature) {
        this.$message.warning(this.$t('SeaExport.ContractRatePropertyRequired'))
        return
      }
      if (this.form.weatherNac && !this.form.defaultParam) {
        this.$message.warning(this.$t('SeaExport.NACRequired'))
        return
      }
      if (this.form.weatherNac && !this.form.defaultParam) {
        this.$message.warning(this.$t('SeaExport.NACRequired'))
        return
      }
      if (this.form.weatherNac) {
        if (this.form.nacList.some(item => !item.param)) {
          this.$message.warning(this.$t('SeaExport.NACRequired'))
          return
        }
      }

      if (this.form.applicableProducts === SeaExportConstants.PRODUCT_OTHER.code && !this.form.productName) {
        this.$message.warning(this.$t('SeaExport.CommodityNameRequired'))
        return
      }
      if (this.form.cabinGuarantee === STATE_HAVE.code && !this.form.cabinQuantity) {
        this.$message.warning(this.$t('SeaExport.CargoInsuranceQuantityRequired'))
        return
      }
      if (this.form.cabinGuarantee === STATE_HAVE.code && !this.form.cabinUnit) {
        this.$message.warning(this.$t('SeaExport.CargoInsuranceUnitRequired'))
        return
      }
      if (this.form.validityStart && this.form.validityEnd) {
        if (new Date(this.form.validityStart) > new Date(this.form.validityEnd)) {
          this.$message.warning(this.$t('SeaExport.BeginDateNotLessThanEndDate'))
          return false
        }
      }
      // 船公司约号是否存在
      if (!this.form.uuid) {
        const result = await isExistContractNumber({ contractNumber: this.form.contractNumber }).then(res => res.data)
        if (result > 0) {
          this.$message.warning(this.$t('SeaExport.ContractNumberRequired'))
          return
        }
      }
      const orderedNacList = []
      if (this.form.defaultParam?.trim()) {
        if (this.form.uuids?.[0]) {
          orderedNacList.push({
            uuid: this.form.uuids[0],
            nac: this.form.defaultParam.trim()
          })
        } else {
          orderedNacList.push({ uuid: '', nac: this.form.defaultParam.trim() })
        }
      }
      if (this.form.nacList) {
        this.form.nacList.forEach((item) => {
          if (item.param?.trim()) {
            orderedNacList.push({ uuid: item.uuid, nac: item.param.trim() })
          }
        })
      }
      if (this.form.applicableRoutes) {
        this.form.applicableRoutes = Array.isArray(this.form.applicableRoutes)
          ? this.form.applicableRoutes.join(',')
          : this.form.applicableRoutes
      }
      if (!this.form.mqc) {
        this.form.mqc = 0
      }
      if (this.form.weatherEnabled === '') {
        this.form.weatherEnabled = true
      }
      const submitData = {
        ...this.form,
        nacList: orderedNacList,
        removeUuids: this.removeUuids
      }
      this.shipingContractLoading = getLoading4Cxt()
      saveShippingContract(submitData).then((res) => {
        if (!this.form.uuid) {
          this.$message.success(this.$t('common.tips.saveSuccess'))
        } else {
          this.$message.success(this.$t('common.tips.editSuccess'))
        }
      }).then(() => {
        // 通知父组件刷新
        this.$emit('refresh')
      }).finally(() => {
        this.close()
        this.shipingContractLoading.close()
      })
    },
    validityStartChange(value) {
      this.form.validityStart = value
    },
    validityEndChange(value) {
      this.form.validityEnd = value
    },
    handleNacChange(value) {
      this.showNacFields = value === 1
      // 如果选择"否"，清空NAC相关数据
      if (!this.showNacFields) {
        this.form.defaultParam = ''
        this.form.nacList = []
      }
    },
    // 适用品名如果选择其他那展示品名
    handleProductNameChange(value) {
      this.showProductName = value === SeaExportConstants.PRODUCT_OTHER.code
      if (!this.showProductName) {
        this.form.productName = ''
      }
    },
    // 舱保选择有 展示舱保单位和数量
    handleCabinGuaranteeChange(value) {
      this.showCabinGuarantee = value === STATE_HAVE.code
      if (!this.showCabinGuarantee) {
        this.form.cabinQuantity = 0
        this.form.cabinUnit = ''
      }
    },
    handleContractNumberInput(value) {
      // 只允许：A-Za-z0-9-/ .&#*,
      const filtered = value.replace(/[^A-Za-z0-9\-/ .&#*,]/g, '')
      if (value !== filtered) {
        this.$nextTick(() => {
          this.form.contractNumber = filtered
        })
      }
    }
  }
}
</script>
<style scoped>
/* 对话框内边距调整 */
.make-invoice-adjust-balance-dialog ::v-deep .el-dialog__body {
  padding: 10px 20px;
}

/* 表单整体布局 */
.el-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 0; /* 行间距 */
}

/* 表单项基础样式 */
.compact-form-item {
  width: 50%; /* 默认占一半宽度 */
  padding-right: 10px;
  box-sizing: border-box; /* 重要：内边距计入宽度 */
  margin-bottom: 0;
}

/* 全宽表单项（合同号专用） */
.full-width-item {
  width: 100% !important; /* 强制100%宽度 */
  padding-right: 0 !important; /* 移除右侧内边距 */
}

/* 确保所有输入控件占满容器 */
.compact-form-item ::v-deep .el-input,
.compact-form-item ::v-deep .el-select,
.compact-form-item ::v-deep .el-date-editor {
  width: 100% !important;
}

/* 标签样式优化 */
.compact-form-item ::v-deep .el-form-item__label {
  padding-bottom: 2px;
  margin-bottom: 0;
  line-height: 1.2;
  display: block;
}

/* 内容区域调整 */
.compact-form-item ::v-deep .el-form-item__content {
  margin-top: 0;
  line-height: normal;
}

/* NAC输入框容器特殊处理 */
.nac-input-container {
  display: flex;
  align-items: center;
  width: 100%;
}
</style>
